const MAX_PICKUP_DATE_TEXT = 'Retire seu pacote até';
const TRACKING_CODE_TEXT = 'Código de rastreamento';

export { MAX_PICKUP_DATE_TEXT, TRACKING_CODE_TEXT };
